var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSunny(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7461_18946",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7461_18946)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.60808 14.6866C6.80774 14.6866 4.52954 12.4084 4.52954 9.60808C4.52954 6.80774 6.80774 4.52954 9.60808 4.52954C12.4084 4.52954 14.6866 6.80774 14.6866 9.60808C14.6866 12.4084 12.4084 14.6866 9.60808 14.6866ZM9.60808 5.56192C7.37706 5.56192 5.56238 7.37706 5.56238 9.60762C5.56238 11.8382 7.37752 13.6533 9.60808 13.6533C11.8386 13.6533 13.6538 11.8382 13.6538 9.60762C13.6538 7.37706 11.8386 5.56192 9.60808 5.56192Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.66843 9.09143H1V10.1243H3.66843V9.09143Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.13 9.09143H15.4615V10.1243H18.13V9.09143Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.93827 3.18398L3.20795 3.91431L5.03425 5.74061L5.76458 5.01028L3.93827 3.18398Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1199 13.3653L13.3895 14.0956L15.2158 15.9219L15.9462 15.1916L14.1199 13.3653Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1243 1H9.09143V3.66843H10.1243V1Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1243 15.4615H9.09143V18.13H10.1243V15.4615Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2157 3.18432L13.3894 5.01062L14.1197 5.74095L15.946 3.91464L15.2157 3.18432Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.03437 13.3655L3.20807 15.1918L3.9384 15.9221L5.7647 14.0958L5.03437 13.3655Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunny);
export default __webpack_public_path__ + "static/media/sunny.6c9c16da67bf335fcea8ac05f07a62a0.svg";
export { ForwardRef as ReactComponent };